<template>
    <div class="d-flex align-center justify-center my-6" style="gap: 0;">
        <template v-for="(step, index) in steps" :key="index">
            <div class="d-flex flex-column align-center" style="min-width: 80px;">
                <div
                    class="step-circle d-flex align-center justify-center"
                    :class="{
                        'step-active': index + 1 === currentStep,
                        'step-completed': index + 1 < currentStep,
                        'step-upcoming': index + 1 > currentStep,
                    }"
                >
                    <v-icon v-if="index + 1 < currentStep" size="18" color="white">mdi-check</v-icon>
                    <span v-else>{{ index + 1 }}</span>
                </div>
                <span class="step-label mt-1" :class="{'text-primary font-weight-medium': index + 1 === currentStep, 'step-label-completed': index + 1 < currentStep}">
                    {{ step }}
                </span>
            </div>
            <div
                v-if="index < steps.length - 1"
                class="step-line"
                :class="{'step-line-completed': index + 1 < currentStep}"
            />
        </template>
    </div>
</template>

<script setup>
defineProps({
    steps: {type: Array, required: true},
    currentStep: {type: Number, required: true},
});
</script>

<style scoped>
.step-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.step-active {
    background: linear-gradient(135deg, rgba(var(--v-theme-primary), 1), rgba(var(--v-theme-primary), 0.8));
    color: white;
    box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.4);
}

.step-completed {
    background: rgba(var(--v-theme-primary), 1);
    color: white;
}

.step-upcoming {
    background: #e0e0e0;
    color: #9e9e9e;
}

.step-line {
    width: 48px;
    height: 2px;
    background: #e0e0e0;
    margin: 0 4px;
    margin-bottom: 20px;
    transition: background 0.3s ease;
}

.step-line-completed {
    background: rgba(var(--v-theme-primary), 1);
}

.step-label {
    font-size: 12px;
    color: #9e9e9e;
    white-space: nowrap;
}

.step-label-completed {
    color: rgba(var(--v-theme-primary), 0.8);
}
</style>
